import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'camelCaseToSentenceCase',
    standalone: false
})
export class CamelCaseToSentenceCasePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        const temp = value.replace(/([A-Z])/g, ' $1');
        return temp.charAt(0).toUpperCase() + temp.slice(1);
    }
}
